import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="sticky top-0 w-full z-50 py-2 sm:py-5 bg-gradient-to-r to-nav-gradient-to from-nav-gradient-from h-21">
      <div className="flex items-center justify-between px-3">
        <Link to="/" className="text-white text-sm pl-2">
          <h1>Shri Saibaba Sansthan Trust, Lodhi Road</h1>
        </Link>

        <div
          onClick={() => setOpen(!open)}
          className="text-2xl  text-white absolute right-8 text-end cursor-pointer lg:hidden"
        >
          <i className={open ? "bx bx-x" : "bx bx-menu"}></i>
        </div>

        <div>
          <ul
            className={`lg:flex lg:items-center lg:pb-0 pb-8 absolute lg:static lg:z-auto z-[-1] left-0 w-full lg:w-auto pr-2 ${
              open
                ? "opacity-100 max-md:bg-gradient-to-r to-nav-gradient-to from-nav-gradient-from "
                : "top-[-600px] lg:opacity-100"
            }  lg:opacity-100`}
          >
            <li className=" lg:pl-3 md:pl-3 md:ml-5  text-sm md:my-0 py-4 px-3 hover:bg-[#BF9F62]">
              <span className="cursor-pointer pt-0.5 font-header font-semibold uppercase text-white ">
                <Link to="/" onClick={() => setOpen(!open)}>
                  Home
                </Link>
              </span>
            </li>

            <li className="lg:pl-0 md:pl-0 md:ml-5  text-sm md:my-0 py-4 px-3 hover:bg-[#BF9F62]">
              <span className="cursor-pointer pt-0.5 font-header font-semibold uppercase text-white ">
                <Link to="/#" onClick={() => setOpen(!open)}>
                  SAI Temple
                </Link>
              </span>
            </li>

            <li className="lg:pl-0 md:pl-0 md:ml-5  text-sm md:my-0 py-4 px-3 hover:bg-[#BF9F62]">
              <span className="cursor-pointer pt-0.5 font-header font-semibold uppercase text-white ">
                <Link to="/#" onClick={() => setOpen(!open)}>
                  Notification
                </Link>
              </span>
            </li>

            <li className="lg:pl-0 md:pl-0 md:ml-5  text-sm md:my-0 py-4 px-3 hover:bg-[#BF9F62]">
              <span className="cursor-pointer pt-0.5 font-header font-semibold uppercase text-white ">
                <Link to="/accomodations" onClick={() => setOpen(!open)}>
                  Online Booking
                </Link>
              </span>
            </li>

            <li className="lg:pl-0 md:pl-0 md:ml-5  text-sm md:my-0 py-4 px-3 hover:bg-[#BF9F62]">
              <span className="cursor-pointer pt-0.5 font-header font-semibold uppercase text-white ">
                <Link to="/#" onClick={() => setOpen(!open)}>
                  Contact us
                </Link>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Header;
